import { PayloadAction, createSlice } from "@reduxjs/toolkit"
import { QrPaymentUrlParams, IQrcInfo } from "../../api/interface"

type IC2BSlice = {
  qrParams: QrPaymentUrlParams | undefined
  qrcInfo: IQrcInfo | undefined
  outcomePaymentId: string | undefined
  isPollingPaymentStatus: boolean
}

const initialState: IC2BSlice = {
  qrParams: undefined,
  qrcInfo: undefined,
  outcomePaymentId: undefined,
  isPollingPaymentStatus: false,
}

const c2bSlice = createSlice({
  name: "c2bPush",
  initialState,
  reducers: {
    setQrParams: (state, action: PayloadAction<QrPaymentUrlParams>) => {
      state.qrParams = action.payload
    },
    setQrcInfo: (state, action: PayloadAction<IQrcInfo | undefined>) => {
      state.qrcInfo = action.payload
    },
    startPaymentStatusPolling: (state, action: PayloadAction<string>) => {
      state.outcomePaymentId = action.payload
      state.isPollingPaymentStatus = true
    },
    stopPaymentStatusPolling: (state) => {
      state.isPollingPaymentStatus = false
    },
    resetSlice: () => initialState,
  },
})

export const {
  setQrParams,
  setQrcInfo,
  startPaymentStatusPolling,
  stopPaymentStatusPolling,
  resetSlice,
} = c2bSlice.actions

export default c2bSlice.reducer
